import { curveLinear, curveStepAfter } from '@visx/curve'
import { LinePath, AreaClosed } from '@visx/shape'

import { useStyles } from './line-paths.style'

export const Curve = {
  linear: 'linear',
  stepAfter: 'stepAfter'
}

const curveFactory = {
  [Curve.linear]: curveLinear,
  [Curve.stepAfter]: curveStepAfter
}

export const LinePaths = function ({ series, scaleX: x, scaleY: y, curve = Curve.linear, showPoints = true }) {
  const classes = useStyles()

  function handleInvalid (value) {
    if (isNaN(value)) {
      return 0
    }
    return value ?? 0
  }

  const scaleX = (value) => handleInvalid(x(value))
  const scaleY = (value) => handleInvalid(y(value))

  return series.map(({ id, points, color, bands = [] }) => (
    <g key={id}>
      {bands.map(({ points, color }, i) => (
        <AreaClosed
          key={i}
          data={points}
          x={({ x }) => scaleX(x)}
          y0={({ y0 }) => scaleY(y0)}
          y1={({ y1 }) => scaleY(y1)}
          yScale={scaleY}
          className={classes.line}
          fill={color}
          curve={curveFactory[curve]}
        />
      ))}
      <LinePath
        data={points}
        x={({ x }) => scaleX(x)}
        y={({ y }) => scaleY(y)}
        className={classes.line}
        stroke={color}
        curve={curveFactory[curve]}
      />
      {showPoints && points.map(({ x, y }) => (
        <circle key={`${x}-${y}`}
          r={4}
          fill="white"
          stroke={color}
          strokeWidth={2}
          cx={scaleX(x)}
          cy={scaleY(y)}
        />
      ))}
    </g>)
  )
}
